module.exports = __webpack_public_path__ + "media/images/ui__infoBox--dark-f284264e7feb8ecc28a7e26e1096c187.png";